// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1kLCM","content":"LayoutSettings_content__YUIdw"};